<template>
  <div class="custom-popup" v-if="popup && popup.show && popup.show === true">
    <div class="custom-popup-bg" @click="closePopup"></div>
    <transition name="slide">
      <div v-if="show_container" :class="$store.getters.is_mobile_or_tablet ? 'custom-popup-wrapper mobile-popup' : 'custom-popup-wrapper'">
        <div class="custom-popup-header-wrapper">
          <div class="custom-popup-header-title">
            <slot name="header_title">
              {{ popup.title }}
            </slot>
          </div>
          <div class="close-button" @click="closePopup">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.3594 10.455L20.2046 2.57078C20.692 2.08136 20.6901 1.28922 20.2002 0.802217C19.7104 0.314801 18.9191 0.31676 18.4317 0.806598L10.5864 8.6908L2.70181 0.845557C2.21198 0.35814 1.42067 0.3601 0.93325 0.849938C0.445832 1.33936 0.447794 2.1315 0.937631 2.6185L8.82225 10.4637L0.976589 18.348C0.489171 18.8374 0.491133 19.6295 0.980969 20.1165C1.22589 20.3598 1.54638 20.4812 1.86616 20.4804C2.18593 20.4796 2.50582 20.3566 2.74953 20.1117L10.5952 12.2275L18.4794 20.0728C18.7243 20.3165 19.0448 20.4378 19.3646 20.437C19.6844 20.4362 20.0043 20.3133 20.248 20.0684C20.7354 19.579 20.7334 18.7868 20.2436 18.2998L12.3594 10.455Z" fill="#2C3236"/>
            </svg>
          </div>
        </div>
        <div class="custom-popup-body-wrapper">
          <div class="custom-popup-logo" v-if="popup.show_logo === true">
            <svg style="fill:none" v-if="!$store.getters.getColorTheme" viewBox="0 0 57.826557 59.086296" height="59.086296" width="57.826557">
              <path
                style="fill:#ff4402" id="path2" d="M 27.751606,33.609546 1.733766,5.2163961 C 1.117986,4.5444061 -0.00225419,4.9816461 3.4070691e-6,5.8931061 L 0.05303471,27.304546 c 5.867e-4,0.2368 0.0854033,0.4657 0.2392873,0.6458 l 26.02378399,30.7843 c 0.6032,0.7059 1.759,0.2776 1.7567,-0.6508 l -0.059,-23.8026 c -6e-4,-0.2487 -0.0942,-0.4884 -0.2622,-0.6717 z" />
              <path
                style="fill:#2c3236" id="path4" d="m 15.572906,1.6665061 -12.95621,0.0321 c -0.87218,0.00215 -1.32214,1.0434 -0.72602,1.68007 l 26.28333,28.0710699 c 0.398,0.425 1.0737,0.4205 1.466,-0.0098 l 25.7071,-28.1998199 c 0.5849,-0.64161 0.1282,-1.67244 -0.74,-1.6703 l -5.689,0.0141 c -0.0811,1.9e-4 -0.1618,0.01028 -0.2405,0.03003 l -7.2235,1.81323 c -0.1684,0.04227 -0.3229,0.12777 -0.4483,0.24804 l -11.4085,10.9532199 c -0.4003,0.3843 -1.0372,0.3683 -1.4177,-0.0357 L 16.301906,1.9802861 c -0.1892,-0.20087 -0.4531,-0.31446 -0.729,-0.31378 z" />
              <path
                style="clip-rule:evenodd;fill:#ff4402;fill-rule:evenodd" id="path6" d="m 48.562506,0.0780874 c 0.1107,-0.0412214 0.2277,-0.0624727 0.3458,-0.0627652 L 55.094006,1.397673e-6 c 0.2464,-6.10110003e-4 0.4466,0.198600702327 0.4472,0.444949702327 7e-4,0.24635 -0.1986,0.44655 -0.4449,0.44716 l -6.1413,0.015211 c -0.0667,1.65e-4 -0.1331,0.009049 -0.1974,0.026427 l -7.1821,1.927347 c -0.2109,0.05694 -0.3384,-0.19399 -0.2172,-0.3349 0.0359,-0.04172 0.0909,-0.05967 0.143,-0.07719 z" />
              <path
                style="clip-rule:evenodd;fill:#2c3236;fill-rule:evenodd" id="path8" d="m 39.402406,43.709146 c -6e-4,-0.2362 0.0827,-0.4651 0.235,-0.6458 l 6.6691,-7.9071 c 0.5991,-0.7103 1.7585,-0.2883 1.7608,0.641 l 7e-4,0.2881 c 0.0024,0.9334 1.1704,1.3531 1.7663,0.6345 l 7.5868,-9.1499 c 0.1491,-0.1797 0.2304,-0.4059 0.2298,-0.6394 l -0.0527,-21.2968199 c -0.0024,-0.92029 -1.1431,-1.34729 -1.7491,-0.6547 l -7.5881,8.6723199 c -0.1597,0.1826 -0.2475,0.4171 -0.2469,0.6597 l 0.0158,6.3666 c 6e-4,0.2532 -0.095,0.4971 -0.2676,0.6824 l -6.6708,7.166 c -0.6168,0.6626 -1.7262,0.2277 -1.7285,-0.6775 l -0.0052,-2.1215 c -0.0023,-0.9104 -1.1225,-1.3426 -1.7357,-0.6697 l -7.6366,8.3804 c -0.168,0.1845 -0.2609,0.4252 -0.2603,0.6747 l 0.0584,23.5544 c 0.0022,0.9155 1.1329,1.3451 1.7424,0.6621 l 7.6363,-8.5555 c 0.1637,-0.1836 0.254,-0.4211 0.2534,-0.6671 z m -0.5665,5.935 c 0.1639,-0.1835 0.2541,-0.4211 0.2535,-0.667 l -0.0134,-5.3927 c -6e-4,-0.2381 0.084,-0.4687 0.2385,-0.6498 l 7.3991,-8.6804 c 0.6012,-0.7051 1.7553,-0.2817 1.7575,0.645 l 5e-4,0.2052 c 0.0024,0.9338 1.1713,1.3532 1.7668,0.6339 l 6.857,-8.2831 c 0.1487,-0.1796 0.2298,-0.4056 0.2293,-0.6388 l -0.0503,-20.2944099 c -0.0024,-0.92248 -1.1477,-1.34829 -1.752,-0.65134 l -6.858,7.9086499 c -0.1579,0.182 -0.2445,0.4152 -0.2439,0.6562 l 0.0157,6.3675 c 6e-4,0.2538 -0.0954,0.4983 -0.2687,0.6837 l -7.4011,7.9223 c -0.6173,0.6608 -1.7249,0.2255 -1.7272,-0.6789 l -0.0053,-2.1583 c -0.0023,-0.9105 -1.1225,-1.3427 -1.7357,-0.6698 l -6.9863,7.6669 c -0.1681,0.1845 -0.261,0.4252 -0.2604,0.6747 l 0.056,22.5655 c 0.0022,0.9155 1.1329,1.3451 1.7424,0.6621 z" />
              <path
                style="clip-rule:evenodd;fill:#2c3236;fill-rule:evenodd" id="path10" d="m 47.847706,14.311046 0.0158,6.3666 c 5e-4,0.2111 -0.0792,0.4143 -0.2229,0.5688 l -6.6709,7.166 c -0.5141,0.5521 -1.4386,0.1898 -1.4404,-0.5647 l -0.0052,-2.1214 c -0.0027,-1.0621 -1.3095,-1.5664 -2.025,-0.7814 l -7.6366,8.3805 c -0.1961,0.2151 -0.3045,0.496 -0.3037,0.7871 l 0.0584,23.5544 c 0.0026,1.068 1.3217,1.5693 2.0329,0.7725 l 7.6362,-8.5556 c 0.191,-0.2142 0.2964,-0.4913 0.2957,-0.7782 l -0.0134,-5.3971 c -5e-4,-0.197 0.069,-0.3878 0.1959,-0.5383 l 6.669,-7.9071 c 0.4993,-0.5919 1.4655,-0.2403 1.4674,0.5341 l 7e-4,0.2881 c 0.0027,1.089 1.3656,1.5786 2.0606,0.7404 l 7.5869,-9.1499 c 0.1738,-0.2097 0.2688,-0.4737 0.2681,-0.7461 l -0.0528,-21.2967599 c -0.0026,-1.07367 -1.3335,-1.57185 -2.0405,-0.76381 l -7.5882,8.6723699 c -0.1863,0.213 -0.2887,0.4866 -0.288,0.7695 z m 9.1194,13.0378 -6.857,8.2831 c -0.4962,0.5994 -1.4703,0.2499 -1.4722,-0.5283 l -5e-4,-0.2052 c -0.0027,-1.0811 -1.3491,-1.5751 -2.0505,-0.7523 l -7.399,8.6802 c -0.1803,0.2115 -0.279,0.4804 -0.2783,0.7581 l 0.0134,5.3928 c 5e-4,0.205 -0.0748,0.403 -0.2112,0.5558 l -6.986,7.8272 c -0.508,0.5691 -1.4502,0.211 -1.4522,-0.5518 l -0.0558,-22.5656 c -5e-4,-0.2079 0.0769,-0.4084 0.2169,-0.5621 l 6.9864,-7.6669 c 0.511,-0.5608 1.4445,-0.2006 1.4464,0.5581 l 0.0053,2.1583 c 0.0027,1.0551 1.2948,1.563 2.0151,0.7919 l 7.4011,-7.9221 c 0.2021,-0.2164 0.3141,-0.5017 0.3134,-0.7977 l -0.0157,-6.3675 c -5e-4,-0.2009 0.0717,-0.3951 0.2033,-0.5469 l 6.858,-7.9086199 c 0.5036,-0.58078 1.458,-0.22594 1.46,0.54279 l 0.0502,20.2943299 c 4e-4,0.1944 -0.0671,0.3827 -0.1911,0.5324 z m -17.3297,15.7141 c -0.1524,0.1807 -0.2357,0.4096 -0.2351,0.646 l 0.0134,5.3971 c 5e-4,0.2459 -0.0897,0.4835 -0.2535,0.667 l -7.6363,8.5556 c -0.6095,0.6829 -1.7401,0.2534 -1.7424,-0.6621 l -0.0583,-23.5544 c -7e-4,-0.2495 0.0921,-0.4902 0.2602,-0.6746 l 7.6366,-8.3806 c 0.6132,-0.6728 1.7335,-0.2406 1.7357,0.6698 l 0.0052,2.1215 c 0.0023,0.9052 1.1117,1.3401 1.7285,0.6775 l 6.6708,-7.1659 c 0.1726,-0.1854 0.2682,-0.4294 0.2676,-0.6826 l -0.0157,-6.3666 c -6e-4,-0.2425 0.0871,-0.477 0.2468,-0.6596 l 7.5882,-8.6723499 c 0.606,-0.6926 1.7467,-0.26559 1.749,0.6547 l 0.0527,21.2967499 c 6e-4,0.2335 -0.0807,0.4599 -0.2297,0.6396 l -7.587,9.1498 c -0.5958,0.7185 -1.7639,0.2989 -1.7661,-0.6346 l -7e-4,-0.2881 c -0.0024,-0.9292 -1.1618,-1.3512 -1.7609,-0.6409 z m -0.5481,5.9139 c 6e-4,0.246 -0.0896,0.4835 -0.2535,0.667 l -6.9859,7.8271 c -0.6096,0.6829 -1.7402,0.2534 -1.7426,-0.6621 l -0.0559,-22.5655 c -6e-4,-0.2495 0.0923,-0.4902 0.2604,-0.6746 l 6.9863,-7.6669 c 0.6132,-0.673 1.7335,-0.2407 1.7357,0.6697 l 0.0053,2.1583 c 0.0023,0.9044 1.1099,1.3397 1.7272,0.6788 l 7.4011,-7.9222 c 0.1732,-0.1855 0.2693,-0.43 0.2687,-0.6838 l -0.0157,-6.3673 c -6e-4,-0.2411 0.086,-0.4742 0.2439,-0.6564 l 6.858,-7.9085899 c 0.6043,-0.69694 1.7497,-0.27112 1.752,0.65135 l 0.0503,20.2943399 c 5e-4,0.2332 -0.0806,0.4593 -0.2293,0.6389 l -6.857,8.283 c -0.5955,0.7193 -1.7644,0.2999 -1.7668,-0.6338 l -5e-4,-0.2052 c -0.0022,-0.9266 -1.1563,-1.3502 -1.7575,-0.6449 l -7.3991,8.6802 c -0.1545,0.1813 -0.2391,0.4117 -0.2385,0.6499 z" />
              <path
                style="clip-rule:evenodd;fill:#2c3236;fill-rule:evenodd" id="path12" d="m 29.948206,50.511246 c -0.1288,-0.1245 -0.1359,-0.3287 -0.0159,-0.4617 l 27.3148,-30.2962 c 0.126,-0.1397 0.3427,-0.1471 0.478,-0.0164 0.1288,0.1244 0.1359,0.3286 0.0159,0.4617 l -27.3148,30.2961 c -0.126,0.1397 -0.3427,0.1472 -0.478,0.0165 z" />
              <path
                style="clip-rule:evenodd;fill:#2c3236;fill-rule:evenodd" id="path14" d="m 29.795406,47.891746 c -0.1283,-0.1239 -0.1359,-0.327 -0.0171,-0.4602 l 27.2358,-30.545 c 0.1257,-0.1409 0.3433,-0.149 0.4791,-0.0178 0.1283,0.1239 0.1359,0.3271 0.0172,0.4602 l -27.2359,30.545 c -0.1257,0.141 -0.3433,0.1491 -0.4791,0.0178 z" />
              <path
                style="clip-rule:evenodd;fill:#2c3236;fill-rule:evenodd" id="path16" d="m 29.721306,38.246246 c -0.1287,-0.1244 -0.1358,-0.3285 -0.0161,-0.4616 l 9.0396,-10.0433 c 0.1259,-0.1398 0.3428,-0.1474 0.4781,-0.0167 0.1288,0.1244 0.1359,0.3285 0.0161,0.4615 l -9.0396,10.0434 c -0.1259,0.1399 -0.3427,0.1475 -0.4781,0.0167 z" />
              <path
                style="clip-rule:evenodd;fill:#2c3236;fill-rule:evenodd" id="path18" d="m 29.728206,41.239346 c -0.1284,-0.124 -0.1358,-0.3275 -0.0168,-0.4606 l 9.3944,-10.5062 c 0.1257,-0.1407 0.3431,-0.1487 0.4787,-0.0175 0.1285,0.124 0.136,0.3274 0.0169,0.4606 l -9.3944,10.5062 c -0.1257,0.1406 -0.3431,0.1486 -0.4788,0.0175 z" />
              <path
                style="clip-rule:evenodd;fill:#2c3236;fill-rule:evenodd" id="path20" d="m 30.070106,44.234146 c -0.1292,-0.1248 -0.1358,-0.3296 -0.0152,-0.4626 l 27.1185,-29.8832 c 0.1261,-0.139 0.3423,-0.1461 0.4772,-0.0157 0.1292,0.1248 0.136,0.3295 0.0153,0.4626 l -27.1186,29.8833 c -0.1261,0.139 -0.3422,0.146 -0.4772,0.0156 z" />
              <path
                style="clip-rule:evenodd;fill:#2c3236;fill-rule:evenodd" id="path22" d="m 29.977806,56.518446 c -0.1296,-0.1252 -0.1359,-0.3309 -0.014,-0.4638 l 8.8486,-9.6533 c 0.1265,-0.1379 0.3417,-0.1445 0.4763,-0.0145 0.1296,0.1252 0.1358,0.331 0.014,0.4639 l -8.8487,9.6533 c -0.1264,0.1379 -0.3416,0.1445 -0.4762,0.0144 z" />
              <path
                style="clip-rule:evenodd;fill:#2c3236;fill-rule:evenodd" id="path24" d="m 47.133106,34.317246 c -0.129,-0.1247 -0.1358,-0.3294 -0.0153,-0.4623 l 9.767,-10.7818 c 0.1261,-0.1392 0.3424,-0.1464 0.4774,-0.0159 0.1291,0.1246 0.136,0.3293 0.0155,0.4623 l -9.7672,10.7818 c -0.1261,0.1392 -0.3423,0.1464 -0.4774,0.0159 z" />
              <path style="clip-rule:evenodd;fill:#2c3236;fill-rule:evenodd" id="path26" d="m 29.884606,53.655746 c -0.1296,-0.1253 -0.1358,-0.331 -0.0141,-0.4639 l 8.8488,-9.6534 c 0.1264,-0.1379 0.3417,-0.1444 0.4761,-0.0144 0.1297,0.1253 0.136,0.331 0.0142,0.4638 l -8.8487,9.6535 c -0.1264,0.1379 -0.3417,0.1444 -0.4763,0.0144 z" />
            </svg>
            <svg v-if="$store.getters.getColorTheme" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.618602 27.8564L0.620314 27.8585L27.0338 59.3188C27.034 59.319 27.0342 59.3193 27.0344 59.3195C27.3489 59.6889 27.9527 59.4661 27.9527 58.9803V34.7041C27.9527 34.5739 27.9042 34.4483 27.8166 34.3521L28.1396 34.0569L27.8166 34.3521L1.40139 5.32845C1.08043 4.97579 0.494376 5.20328 0.494376 5.68053V27.5179C0.494376 27.642 0.538408 27.762 0.618602 27.8564ZM0.241971 28.1773L26.6571 59.6396C27.2694 60.361 28.4471 59.9273 28.4471 58.9803V34.7041C28.4471 34.4504 28.3525 34.2058 28.1819 34.0184L1.76671 4.99474C1.14153 4.30782 0 4.75093 0 5.68053V27.5179C0 27.7595 0.0857674 27.9932 0.241971 28.1773Z" fill="#FF4402"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.74977 3.48016C0.997243 2.67097 1.57002 1.35205 2.67396 1.35205H15.8637C16.213 1.35205 16.5467 1.49691 16.7855 1.75222L28.8454 14.6456C29.1377 14.9581 29.6283 14.9717 29.9374 14.6758L41.5793 3.53355C41.7382 3.38143 41.934 3.2735 42.1474 3.22042L49.5056 1.38937C49.6052 1.36458 49.7075 1.35205 49.8101 1.35205H55.6017C56.7006 1.35205 57.2754 2.66061 56.5331 3.47238L30.2916 32.1682C29.7937 32.7126 28.9384 32.7162 28.436 32.176L1.74977 3.48016ZM2.67396 1.84733C2.00209 1.84733 1.65348 2.65005 2.11148 3.14254L28.7977 31.8384C29.1035 32.1671 29.6241 32.165 29.9271 31.8336L56.1685 3.1378C56.6203 2.64375 56.2705 1.84733 55.6017 1.84733H49.8101C49.7476 1.84733 49.6854 1.85496 49.6248 1.87005L42.2665 3.7011C42.1367 3.73341 42.0175 3.79909 41.9208 3.89167L30.2789 15.034C29.7711 15.52 28.965 15.4977 28.4847 14.9842L16.4247 2.09089C16.2794 1.9355 16.0763 1.84733 15.8637 1.84733H2.67396Z" fill="#FF4402"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M49.4519 0.06314C49.5647 0.0213782 49.684 0 49.8042 0H56.1015C56.3522 0 56.5556 0.203679 56.5556 0.45493C56.5556 0.706181 56.3522 0.90986 56.1015 0.90986H49.8494C49.7815 0.90986 49.7139 0.918754 49.6483 0.936314L42.332 2.88386C42.1171 2.9414 41.988 2.68516 42.1117 2.54175C42.1484 2.49929 42.2044 2.48112 42.2576 2.46338L49.4519 0.06314Z" fill="#FF4402"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M40.0167 44.5387C40.0167 44.2977 40.1021 44.0645 40.2577 43.8806L47.0669 35.8331C47.6785 35.1101 48.8578 35.5435 48.8578 36.4912V36.7851C48.8578 37.737 50.0459 38.168 50.6543 37.4367L58.401 28.124C58.5531 27.9411 58.6365 27.7105 58.6365 27.4724V5.75181C58.6365 4.81322 57.4762 4.37484 56.8576 5.07968L49.1108 13.9054C48.9478 14.0912 48.8578 14.3301 48.8578 14.5775V21.0708C48.8578 21.329 48.7598 21.5776 48.5838 21.7662L41.7746 29.0578C41.145 29.732 40.0167 29.2857 40.0167 28.3625V26.1988C40.0167 25.2702 38.8774 24.8266 38.2515 25.5113L30.4561 34.0392C30.2845 34.2269 30.1894 34.4721 30.1894 34.7266V58.7497C30.1894 59.6834 31.3393 60.1244 31.9616 59.4294L39.757 50.7229C39.9242 50.5361 40.0167 50.2941 40.0167 50.0433V44.5387ZM39.4251 50.5903C39.5923 50.4036 39.6848 50.1615 39.6848 49.9107V44.4106C39.6848 44.1678 39.7715 43.9329 39.9292 43.7484L47.4836 34.9142C48.0974 34.1965 49.2711 34.6313 49.2711 35.5764V35.7857C49.2711 36.738 50.4601 37.1688 51.0681 36.4367L58.0696 28.0061C58.2215 27.8233 58.3046 27.593 58.3046 27.3552V6.65698C58.3046 5.71615 57.1397 5.27898 56.5227 5.98825L49.5212 14.0369C49.36 14.2222 49.2711 14.4597 49.2711 14.7056V21.1997C49.2711 21.4586 49.1727 21.7077 48.9959 21.8964L41.4415 29.9575C40.8113 30.6299 39.6848 30.1832 39.6848 29.2608V27.0595C39.6848 26.131 38.5455 25.6873 37.9196 26.3721L30.788 34.1738C30.6164 34.3615 30.5213 34.6068 30.5213 34.8613V57.8758C30.5213 58.8094 31.6712 59.2504 32.2935 58.5554L39.4251 50.5903Z" fill="#FF4402"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M48.6884 14.5776V21.0709C48.6884 21.2861 48.6067 21.4932 48.46 21.6503L41.6508 28.942C41.1262 29.5038 40.1859 29.1319 40.1859 28.3625V26.1988C40.1859 25.1155 38.8567 24.5979 38.1265 25.3968L30.3311 33.9247C30.1309 34.1437 30.0199 34.4298 30.0199 34.7267V58.7498C30.0199 59.839 31.3615 60.3536 32.0876 59.5427L39.883 50.8362C40.078 50.6184 40.1859 50.336 40.1859 50.0433V44.5388C40.1859 44.3379 40.2571 44.1436 40.3867 43.9903L47.1959 35.9428C47.7056 35.3404 48.6884 35.7015 48.6884 36.4913V36.7851C48.6884 37.8958 50.0745 38.3985 50.7842 37.5454L58.5309 28.2327C58.7085 28.0192 58.8057 27.7502 58.8057 27.4724V5.75187C58.8057 4.65684 57.4521 4.1454 56.7303 4.96771L48.9836 13.7934C48.7933 14.0102 48.6884 14.2889 48.6884 14.5776ZM57.9393 27.8977L50.9378 36.3282C50.4311 36.9383 49.4404 36.5794 49.4404 35.7857V35.5765C49.4404 34.4739 48.0709 33.9666 47.3549 34.8039L39.8005 43.6381C39.6165 43.8533 39.5154 44.1273 39.5154 44.4107V49.9107C39.5154 50.1198 39.4383 50.3215 39.299 50.4771L32.1673 58.4422C31.6488 59.0214 30.6905 58.6539 30.6905 57.8758V34.8613C30.6905 34.6492 30.7698 34.4449 30.9127 34.2885L38.0444 26.4867C38.566 25.9161 39.5154 26.2858 39.5154 27.0596V29.2609C39.5154 30.3369 40.8296 30.8582 41.5648 30.0737L49.1192 22.0126C49.3255 21.7924 49.4404 21.5018 49.4404 21.1998V14.7056C49.4404 14.5008 49.5144 14.3028 49.6487 14.1484L56.6502 6.09976C57.1644 5.5087 58.1351 5.87301 58.1351 6.65703V27.3552C58.1351 27.5534 58.0659 27.7454 57.9393 27.8977ZM40.2576 43.8806C40.102 44.0645 40.0166 44.2977 40.0166 44.5388V50.0433C40.0166 50.2942 39.9241 50.5362 39.7569 50.723L31.9615 59.4294C31.3392 60.1244 30.1892 59.6834 30.1892 58.7498V34.7267C30.1892 34.4722 30.2844 34.227 30.456 34.0393L38.2514 25.5114C38.8773 24.8266 40.0166 25.2703 40.0166 26.1988V28.3625C40.0166 29.2857 41.1449 29.7321 41.7745 29.0579L48.5836 21.7662C48.7597 21.5777 48.8577 21.3291 48.8577 21.0709V14.5776C48.8577 14.3302 48.9476 14.0912 49.1107 13.9054L56.8574 5.07974C57.4761 4.37489 58.6364 4.81327 58.6364 5.75187V27.4724C58.6364 27.7105 58.553 27.9411 58.4009 28.1241L50.6541 37.4368C50.0458 38.1681 48.8577 37.7371 48.8577 36.7851V36.4913C48.8577 35.5436 47.6784 35.1102 47.0667 35.8331L40.2576 43.8806ZM39.6847 49.9107C39.6847 50.1616 39.5922 50.4036 39.425 50.5904L32.2934 58.5555C31.6711 59.2505 30.5211 58.8095 30.5211 57.8758V34.8613C30.5211 34.6068 30.6163 34.3616 30.7878 34.1739L37.9195 26.3722C38.5454 25.6874 39.6847 26.1311 39.6847 27.0596V29.2609C39.6847 30.1832 40.8112 30.63 41.4413 29.9575L48.9957 21.8965C49.1726 21.7077 49.271 21.4586 49.271 21.1998V14.7056C49.271 14.4598 49.3598 14.2223 49.5211 14.0369L56.5226 5.98831C57.1396 5.27903 58.3045 5.71621 58.3045 6.65703V27.3552C58.3045 27.5931 58.2213 27.8234 58.0695 28.0062L51.068 36.4367C50.46 37.1688 49.271 36.7381 49.271 35.7857V35.5765C49.271 34.6314 48.0973 34.1965 47.4835 34.9143L39.9291 43.7485C39.7714 43.933 39.6847 44.1678 39.6847 44.4107V49.9107Z" fill="#FF4402"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M30.3752 51.4519C30.2443 51.3246 30.2377 51.1164 30.3601 50.981L58.2437 20.1512C58.3723 20.009 58.5929 20.002 58.7303 20.1356C58.8611 20.2629 58.8678 20.4712 58.7453 20.6066L30.8618 51.4363C30.7332 51.5785 30.5126 51.5855 30.3752 51.4519Z" fill="#FF4402"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M30.2262 48.78C30.0959 48.6532 30.0887 48.446 30.2099 48.3105L58.0137 17.2268C58.1419 17.0834 58.3635 17.0757 58.5014 17.2098C58.6317 17.3365 58.6389 17.5437 58.5177 17.6793L30.7139 48.763C30.5857 48.9064 30.3641 48.9141 30.2262 48.78Z" fill="#FF4402"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M30.1751 38.942C30.0443 38.8148 30.0376 38.6067 30.1598 38.4713L39.3877 28.251C39.5162 28.1087 39.737 28.1015 39.8744 28.2352C40.0052 28.3624 40.0119 28.5705 39.8897 28.7059L30.6618 38.9262C30.5333 39.0686 30.3125 39.0757 30.1751 38.942Z" fill="#FF4402"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M30.1746 41.9947C30.0442 41.8678 30.0371 41.6603 30.1586 41.5248L39.7488 30.8334C39.8772 30.6903 40.0985 30.6827 40.2363 30.8167C40.3667 30.9436 40.3738 31.1511 40.2523 31.2866L30.6621 41.9781C30.5337 42.1211 30.3124 42.1287 30.1746 41.9947Z" fill="#FF4402"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M30.5151 45.0499C30.384 44.9224 30.3776 44.7135 30.5008 44.5781L58.1834 14.169C58.3121 14.0275 58.5322 14.0208 58.6692 14.1542C58.8004 14.2818 58.8068 14.4907 58.6836 14.626L31.001 45.0352C30.8723 45.1766 30.6522 45.1833 30.5151 45.0499Z" fill="#FF4402"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M30.3901 57.5782C30.2585 57.4501 30.2526 57.2403 30.377 57.105L39.4095 47.282C39.5385 47.1417 39.7577 47.1356 39.8943 47.2685C40.026 47.3966 40.0318 47.6064 39.9075 47.7416L30.8749 57.5646C30.7459 57.705 30.5268 57.7111 30.3901 57.5782Z" fill="#FF4402"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M47.9107 34.979C47.7796 34.8515 47.7732 34.6428 47.8962 34.5075L57.8665 23.5359C57.9952 23.3943 58.2154 23.3875 58.3525 23.5209C58.4836 23.6484 58.49 23.8571 58.367 23.9925L48.3968 34.964C48.268 35.1057 48.0479 35.1125 47.9107 34.979Z" fill="#FF4402"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M30.3025 54.6583C30.1709 54.5302 30.165 54.3203 30.2894 54.1851L39.3219 44.3621C39.4509 44.2218 39.6701 44.2157 39.8067 44.3486C39.9384 44.4766 39.9442 44.6865 39.8199 44.8217L30.7873 54.6447C30.6583 54.785 30.4392 54.7912 30.3025 54.6583Z" fill="#FF4402"/>
            </svg>
          </div>

          <div class="custom-popup-body-slot">
            <slot name="body"></slot>
          </div>

          <slot name="footer-buttons">
            <div class="custom-popup-buttons-wrapper" v-if="popup.left_button_show || popup.right_button_show">
              <b-button v-if="popup.left_button_show" :disabled="left_button_disabled" class="detailed" variant="link" @click="popup.left_button_func">
                {{ popup.left_button_text ? $t(popup.left_button_text) : $t('cancel') }}
              </b-button>
              
              

              <b-button 
                v-if="popup.download_button_show"
                class="detailed"
                variant="link"
                @click="popup.download_button_func"
              >
                {{ $t(popup.download_button_text) }}
              </b-button>

              <b-button 
                v-if="popup.copy_to_clipboard_button_show"
                class="detailed"
                variant="link"
                @click="popup.copy_to_clipboard_button_func"
              >
                {{ $t(popup.copy_to_clipboard_button_text) }}
              </b-button>

              <b-button v-if="popup.right_button_show" :disabled="right_button_disabled" class="detailed" variant="link" @click="popup.right_button_func">
                {{ popup.right_button_text ? $t(popup.right_button_text) : $t('select') }}
              </b-button>
            </div>
          </slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CustomPopupAllDevice',
  props: [
    'popup'
  ],
  data () {
    return {
      show_container: false
    }
  },
  watch: {
    'popup.show' () {
      if (this.popup.show) {
        document.addEventListener('keydown', this.onEscape)
      } else {
        document.removeEventListener('keydown', this.onEscape)
      }
      if(this.$store.getters.is_mobile_or_tablet) {
        setTimeout(function() {
          this.toggleShowContainer()
        }.bind(this), 0)
      }
      else {
        this.toggleShowContainer()
      }
    }
  },
  computed: {
    close_button_disabled () {
      if(typeof this.popup.close_button_disabled === 'undefined') {
        return false
      }
      else {
        return this.popup.close_button_disabled
      }
    },
    left_button_disabled () {
      if(typeof this.popup.left_button_disabled === 'undefined') {
        return false
      }
      else {
        return this.popup.left_button_disabled
      }
    },
    right_button_disabled () {
      if(typeof this.popup.right_button_disabled === 'undefined') {
        return false
      }
      else {
        return this.popup.right_button_disabled
      }
    },
  },
  methods: {
    toggleShowContainer () {
      if(this.popup.show) {
        this.show_container = true
      }
      else {
        this.show_container = false
      }
    },
    hideComponent () {
      this.popup.show = false
      if(this.popup.close_button_func) {
        this.popup.close_button_func()
      }
    },
    onEscape (event) {
      if (event.key !== 'Escape' || !this.popup || !this.popup.show) return
      this.closePopup()
    },
    closePopup () {
      if(!this.close_button_disabled) {
        this.show_container = false
        if(this.$store.getters.is_mobile_or_tablet) {
          setTimeout(function() {
            this.hideComponent()
          }.bind(this), 200)
        }
        else {
          this.hideComponent()
        }
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onEscape)
  }
}
</script>

<style lang="scss">
.custom-popup {

  .custom-popup-bg {
    background: #2C3236;
    opacity: 0.6;
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: 200;
    top: 0;
    left: 0;
  }

  .custom-popup-wrapper {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 500px;
    background: #FAFAFA;
    border: 1px solid #CFD0D1;
    box-sizing: border-box;
    box-shadow: 10px 10px 10px rgba(44, 50, 54, 0.5);
    border-radius: 3px;
    z-index: 210;
    height: fit-content;

    .custom-popup-header-wrapper {
      position: relative;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      border-bottom: 2px solid #CFD0D1;

      .close-button {
        cursor: pointer;

        svg {
          width: 12px;
          height: 12px;
        }
      }

      .custom-popup-header-title {
        font-size: 18px;
      }
    }

    .custom-popup-body-wrapper {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      flex-direction: column;

      .custom-popup-logo {
        padding: 20px;
      }

      .custom-popup-body-slot {
        padding: 20px;
        // overflow: auto;
      }

      .custom-popup-buttons-wrapper {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        border-top: 2px solid #CFD0D1;
        padding: 20px;
        margin-top: 20px;

        .detailed {
          width: 160px;
        }
        .detailed:not(:last-child) {
          margin-right: 20px;
        }
      }
    }
  }
}

#app.mobile {
  .custom-popup {

    .custom-popup-bg {
      background: #FFFFFF;
    }
    .custom-popup-wrapper.mobile-popup {
      width: calc(100% - 30px) !important;
      margin: 0 15px;
      bottom: 0;
      top: auto;
      box-shadow: 2px -2px 4px #CFD0D1;

      .custom-popup-header-wrapper {

      }
      .custom-popup-body-wrapper {
        margin: 0;

        .popup-widget-type-body-wrapper {
          margin: 0 15px;
          width: calc(100% - 30px);
          border-bottom: none;
        }
        .custom-popup-buttons-wrapper {

          button {
            width: 50%;
            margin: 0;
            font-size: 18px;
            height: 60px;
          }
          button:first-child {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border: 1px solid #2C3236;
          }
          button:last-child {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            background: #FF4402;
            color: #FFFFFF;
          }
        }
      }
    }
  }
}

@-webkit-keyframes verticShowPopup {
  0% {
    bottom: -1000px;
  }
  100% {
    bottom: 0;
  }
}
@keyframes verticShowPopup {
  0% {
    bottom: -1000px;
  }
  100% {
    bottom: 0;
  }
}

@-webkit-keyframes verticHidePopup {
  0% {
    bottom: 0px;
  }
  100% {
    bottom: -1000px;
  }
}
@keyframes verticHidePopup {
  0% {
    bottom: 0px;
  }
  100% {
    bottom: -1000px;
  }
}

.slide-enter-active {
  -webkit-animation: verticShowPopup 0.5s forwards;
  animation: verticShowPopup 0.5s forwards;
}
.slide-leave-active {
  -webkit-animation: verticHidePopup 0.5s forwards;
  animation: verticHidePopup 0.5s forwards;
}

@-webkit-keyframes horizontShowPopup {
  0% {
    right: -1000px;
  }
  100% {
    right: 0;
  }
}
@keyframes horizontShowPopup {
  0% {
    right: -1000px;
  }
  100% {
    right: 0;
  }
}

@-webkit-keyframes horizontHidePopup {
  0% {
    right: 0px;
  }
  100% {
    right: -1000px;
  }
}
@keyframes horizontHidePopup {
  0% {
    right: 0px;
  }
  100% {
    right: -1000px;
  }
}

#app.mobile:not(.portrait-orientation) {

  .custom-popup {

    .custom-popup-wrapper.mobile-popup {
      bottom: 0;
      right: 0;
      left: auto;
      margin: unset;
      width: 70% !important;
      height: 100%;
      border-top-right-radius: 0;
      border-bottom-left-radius: 20px;
      border-top-left-radius: 20px;
    }
  }

  .slide-enter-active {
    -webkit-animation: horizontShowPopup 0.5s forwards;
    animation: horizontShowPopup 0.5s forwards;
  }
  .slide-leave-active {
    -webkit-animation: horizontHidePopup 0.5s forwards;
    animation: horizontHidePopup 0.5s forwards;
  }
}

.color-theme-dark {
  .custom-popup-bg {
    background: #FAFAFA;
  }
  .custom-popup-wrapper {
    background: #2C3236;
    border: 1px solid #5F6467;

    .custom-popup-header-wrapper {

      border-color: #5F6467;
      .close-button {

        svg {
          path {
            fill: #CFD0D1;
          }
        }
      }
    }
  }
  .custom-popup-buttons-wrapper {
    border-color: #5F6467 !important;
  }

  #app.mobile {
    .custom-popup {
      .custom-popup-bg {
        background: #2C3236;
      }
      .custom-popup-wrapper.mobile-popup {
        border: 1px solid #5F6467;
        box-shadow: none;

        .custom-popup-body-wrapper {
          .custom-popup-buttons-wrapper {
            button:first-child {
              border: 1px solid #CFD0D1;
              color: #CFD0D1
            }
            button:last-child {
              color: #FFFFFF;
            }
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/custom_ui_components/CustomPopupAllDevice.vue